import React from "react"
import { Form as BootstrapForm } from "react-bootstrap"
import { FormikProps } from "formik/dist/types";
import { Tooltip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import {ProductImageStacType} from "../../../types/product";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import DateFieldSelector from "./shared/DateFieldSelector";
import {getDatePickerLimits} from "../../../helpers/dateHelper";
import { AppParametersType } from "../../../types/app";
import translations from "../../../translations";
import classNames from "classnames";

interface PropsType {
  configurations: ConfigurationsType,
  mainInputConfigurations: any,
  scopeConfigurationFields: string,
  disabled?: boolean,
  selectedArea: ShapeType,
  selectedProducts: ProductImageStacType[],
  formProps: FormikProps<any>,
  appParameters: AppParametersType,
  onTop?: boolean
}

const DateFields = (props: PropsType) => {
  const {
    configurations,
    mainInputConfigurations,
    scopeConfigurationFields,
    selectedArea,
    selectedProducts,
    formProps: {
      values
    },
    appParameters,
    onTop = false
  } = props;

  const mainClasses = () => {
    let classes = "row mx-0 mb-3 pt-4"
    if (!onTop) {
      classes += "mt-3 border-top";
    }
    return classes;
  }

  return (
    <div className={mainClasses()}>
      <BootstrapForm.Label className="m-0 px-0 col-3 d-flex">
        <svg className="label-icon"><use xlinkHref="#date-icon" fill="#9A9BA6" /></svg>
        <Tooltip {...DEFAULT_TOOLTIP_PROPS}
          title={translations('dateUTCLeftSearchBar', appParameters.language)}
          placement="right-end"
        >
          <span className="title">
            {mainInputConfigurations.date1.required || mainInputConfigurations.date2.required ? '*' : ''}
            {translations('dateLeftSearchBar', appParameters.language)}
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1"
            />
          </span>
        </Tooltip>
      </BootstrapForm.Label>
      <BootstrapForm.Group className="col-9 m-0 pr-0">
        <div className="d-flex">
          <DateFieldSelector
            key="from"
            fieldName="date1"
            secondaryFieldName="date2"
            containerClassName="form-control arrow-aligned-center d-flex p-0 mr-3"
            {...getDatePickerLimits(appParameters, configurations, scopeConfigurationFields, values, selectedArea, selectedProducts, true)}
            {...props}
          />
          <DateFieldSelector
            key="to"
            fieldName="date2"
            secondaryFieldName="date1"
            containerClassName="form-control arrow-aligned-right d-flex p-0"
            {...getDatePickerLimits(appParameters, configurations, scopeConfigurationFields, values, selectedArea, selectedProducts, false)}
            {...props}
          />
        </div>
      </BootstrapForm.Group>
    </div>
  );
}

export default DateFields;
